module.exports = __webpack_public_path__ + "assets/img/stasticBg.c9ef4b45.png";